<template>
  <div>
    <HeaderName />

    <h2 class="subHeader mt-1 mb-1">
      Enter up to six separate user groups, such as remote staff or contractors,
      to see how much you can expect to spend with Citrix DaaS
      Standard for Google Cloud including Google Cloud consumption.
    </h2>
    <b-row>
      <b-col lg="5" md="5" sm="auto" style="overflow:visible;padding:0%">
        <Form
          v-if="!!store.state.formData"
          :fields="store.state.formData"
          @onSubmit="onFormSubmit"
          class="formBuilderFields"
        />
      </b-col>
      <b-col lg="7" md="7" class="vt-line" style="overflow:visible;">
        <div class="fs-4">
          <p class="fs-2">
            Your user type(s)
          </p>
          <p class="fs-6" v-show="this.store.state.personaData.length == 6">
            You have reached your limit .
          </p>
          <PersonaContainer />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Form from '../containers/Form';
import store from '../../store';
import Button from '../input-controls/Button.vue';
import FormFieldsAPI from '../../services/form-fields';
import HeaderName from '../global/HeaderName.vue';
import PersonaContainer from '../global/PersonaContainer.vue';
import EditPen from '../../assets/icons/editpen.svg';

export default {
  name: 'Landing',
  components: {
    Form,
    HeaderName,
    PersonaContainer,
    Button,
    EditPen,
  },
  data() {
    return {
      store,
    };
  },

  mounted() {
    FormFieldsAPI().then(res => {
      this.store.setFormData(res);
    });
    store.state.personaDataAfterCalculate = [];
  },
  methods: {
    onFormSubmit($event) {
      if (!$event.canSubmit) {
        this.store.setFormData($event.formData);
        return;
      }
      if (store.state.editState === null) {
        this.store.createPersona($event.formData);
      } else {
        this.store.updatePersona($event.formData);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.formBuilderFields {
  padding: 0px 18px 0px;
}
.emptyText {
  position: relative;
  top: -2px;
}
.edit-icon {
  position: relative;
  top: 4px;
}
.card {
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(217, 217, 217, 0.5);
}

.header {
  padding-bottom: 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
.subHeader {
  font-size: 24px;
  font-weight: 300;
  padding: 24px 0px;
  font-weight: normal;
}
.vt-line {
  border-left: 1px solid rgba(0, 0, 0, 0.2);
}
.footer-hz-line {
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  margin-top: 25px;
  margin-bottom: 35px;
}
.fs-2 {
  font-weight: normal;
  font-size: 24px;
  padding: 0%;
}
.fs-3 {
  font-size: 16px;
}
.fs-4 {
  margin-left: 20px;
}
.fs-6 {
  font-size: 12px;
  color: #8c8c8c;
}

@media screen and (max-width: 761px) {
  .fs-4 {
    margin-left: 0px;
  }
  .vt-line {
    border: none;
    margin: 0px;
  }
  .subHeader {
    font-size: 20px;
  }
}
</style>
